import { VisitEncounterMode, VisitEncounterModeFilterParam } from './VisitEncounterModeField.types';
import { VISIT_ENCOUNTER_MODE_ID_MAP } from './VisitEncounterModeField.constants';

export const FILTER_SEPARATOR = ',';

export const getVisitEncounterModeFilterCount = (): number => {
   return Object.keys(VISIT_ENCOUNTER_MODE_ID_MAP).length;
};

export const getVisitEncounterModesFilterSearchParamValue = (
   visitEncounterModes: VisitEncounterMode[]
): VisitEncounterModeFilterParam => {
   return visitEncounterModes
      .map((visitEncounterMode) => VISIT_ENCOUNTER_MODE_ID_MAP[visitEncounterMode])
      .join(FILTER_SEPARATOR);
};

export const getVisitEncounterModeFromSearchParam = (searchParamValue: number): VisitEncounterMode | null => {
   const foundEntry = Object.entries(VISIT_ENCOUNTER_MODE_ID_MAP).find(([, entrySearchParamValue]) => {
      return searchParamValue === entrySearchParamValue;
   });
   return foundEntry ? (foundEntry[0] as VisitEncounterMode) : null;
};

export const mapVisitEncounterModeFilterParamToEncounterMode = (
   visitEncounterModeSearchParam: string | null
): VisitEncounterMode[] => {
   if (!visitEncounterModeSearchParam) {
      return [];
   }

   const selectedVisitEncounterMode = visitEncounterModeSearchParam.split(FILTER_SEPARATOR).reduce((acc, str) => {
      const num = Number(str);
      if (!Number.isNaN(num)) {
         acc.add(num);
      }

      return acc;
   }, new Set());

   if (!selectedVisitEncounterMode.size) {
      return [];
   }

   return Object.entries(VISIT_ENCOUNTER_MODE_ID_MAP).reduce<VisitEncounterMode[]>((acc, [encounterMode, id]) => {
      if (selectedVisitEncounterMode.has(id)) {
         acc.push(encounterMode as VisitEncounterMode);
      }

      return acc;
   }, []);
};
